// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"d017ef43","142":"e7b804be","574":"308acc45","825":"b2847a84","883":"f1c23762"}[chunkId] + ".chunk.css";
};